import { Card, CardContent } from "@/components/ui/card";
import { useChateaux } from "@/hooks/useChateaux";
import { useChateauFiltering } from "@/hooks/useChateauFiltering";
import { FilterControls } from "@/components/selector/FilterControls";
import { RecommendationGrid } from "@/components/selector/RecommendationGrid";

interface ChateauSelectorProps {
  compact?: boolean;
}

export const ChateauSelector = ({ compact = false }: ChateauSelectorProps) => {
  const { chateaux, loading } = useChateaux();
  
  const {
    selectedSpace,
    setSelectedSpace,
    selectedBudget,
    setSelectedBudget,
    recommendations,
    hasValidCriteria,
    spaceOptions,
    budgetOptions
  } = useChateauFiltering({ chateaux });

  return (
    <Card className={`${compact ? 'p-6' : 'p-8'} gradient-primary text-white shadow-playful`}>
      <CardContent className="p-0">
        <h3 className={`${compact ? 'text-xl' : 'text-2xl'} font-display font-bold mb-4`}>
          Besoin d'aide pour choisir ?
        </h3>
        <p className="mb-6 opacity-90">
          Répondez à ces 2 questions pour recevoir nos recommandations personnalisées.
          <br />
          <span className="text-sm">Prix valable pour le week-end complet • Transport facile dans une voiture avec hayon</span>
        </p>
        
        <FilterControls
          spaceOptions={spaceOptions}
          budgetOptions={budgetOptions}
          selectedSpace={selectedSpace}
          selectedBudget={selectedBudget}
          onSpaceChange={setSelectedSpace}
          onBudgetChange={setSelectedBudget}
          compact={compact}
        />

        <RecommendationGrid
          recommendations={recommendations}
          loading={loading}
          hasValidCriteria={hasValidCriteria}
          compact={compact}
        />
      </CardContent>
    </Card>
  );
};